import React from 'react'
import { Create } from 'react-admin'
import Form from './form'

const MaterialsCreate = props => {
  return (
    <Create {...props} >
      <Form />
    </Create>
  )
}

export default MaterialsCreate
